// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__IN60l","alertIcon":"ConfirmModal_alertIcon__18Fvs"};